<template>
  <div class="layout">
    <NavPC
      v-if="!isMobile"
      id="nav"
      class="nav-pc"
      :navData="$t('home.nav')"
      @changeNav="changeNav"
      @setLang="setLangConfig"
    />
    <NavMobile
      id="nav"
      class="nav-mobile"
      :navData="$t('home.nav')"
      :logo="logo"
      @changeNav="changeNav"
      v-else
    />
    <slot name="banner">
      <Banner v-if="useBanner" />
    </slot>

    <slot />

    <div class="toast" v-if="showToast && isMobile">敬请期待</div>
  </div>
</template>

<script>
import NavPC from './nav'
import NavMobile from './navMobile'
import Banner from './banner'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'layout',
  components: {
    NavPC,
    NavMobile,
    Banner
  },
  props: {
    useBanner: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showToast: false,
      logo: 'https://static001.geekbang.org/resource/image/d9/6e/d9fdf5e8ea899511244yy656c9f6ca6e.png'
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  created () {
    // console.log(this.$t('nav'))
  },
  methods: {
    ...mapActions([
      'setLang'
    ]),

    setLangConfig (val) {
      this.setLang(val)
    },

    getHash (path) {
      let hash = ''

      if (`${path}`.indexOf('#') > -1) {
        hash = `#${path.split('#')[1]}`
      }

      return hash
    },

    changeNav (item) {
      const hash = this.getHash(item.hash)

      if (item.name.slice(0, 5) === 'https') return window.open(item.name)

      if (item.name !== this.$route.name) {
        this.$router.push({ name: item.name })
          .then(() => {
            if (hash) this.scrollToAnchor(hash)
          })
          .catch(() => {
            if (hash) this.scrollToAnchor(hash)
          })
      } else {
        if (hash) this.scrollToAnchor(hash)
      }
    },

    scrollToAnchor (hash) {
      if (!hash) return
      const nav = document.querySelector('#nav')
      if (!nav) return
      const offset = -nav.offsetHeight
      if (document.querySelector(hash)) {
        this.$scrollTo(hash, 500, { offset })
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo(hash, 500, { offset })
          }, 800)
        })
      }

      this.$router.replace({ hash })
    }
  }
}
</script>

<style lang="scss" scoped>

.layout {
  position: relative;
  overflow: hidden;
  width: 100%;
  // width: 1500px;
  // background: #13101a;

  @include enlayoutInner {
    text-align: left !important;
  }
}

.nav-pc {
  position: fixed; left: 0; right: 0;
  z-index: 200;
  border-bottom: 1px solid #D8D8D8;
  background: #FFFFFF;
}

.nav-mobile {
  // background: #13101A;
}

.toast {
  position: fixed; top: 200px; left: 50%; z-index: 1001;
  width: 100px;
  margin-left: -50px; padding: 0 20px;
  background: #13101a;
  border: 1px solid #13101a;
  border-radius: 30px;
  font-size: 14px;
  // color: #FFF;
}

@include mobile {
  .layout {
    @include enlayoutInner {
      text-align: left !important;
    }
  }
}
</style>
